import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import format from 'date-fns/format';
import * as queryString from "query-string";
import {useHistory, useLocation} from "react-router";
import routes from '../constants/routes.json';
import { DEFAULT_FILTERS, DEFAULT_CURRENCY, DEFAULT_RESIDENCY, DEFAULT_AGE } from '../constants/default';
import { setVendorsLoaded } from '../redux/vendors/action';
import { setResultsLoaded } from '../redux/results/action';
import HomeContent from '../components/HomeContent';
import { useTranslation } from 'react-i18next';
import { getAttributor } from '../utils/activityTracking';
  
function Home({ dispatch, cur, residency }) {
  const location = useLocation();
  const history = useHistory();
  const [params, setParams] = useState();
  const { t, i18n } = useTranslation(); // eslint-disable-line

  useEffect(() => {
    const params = queryString.parse(location.search);

    // qnd fix external links with wrong case
    if (params.fromLocationCode === undefined && params.fromlocationcode) {
      params.fromLocationCode = params.fromlocationcode
    }
    if (params.toLocationCode === undefined && params.tolocationcode) {
      params.toLocationCode = params.tolocationcode
    }
    // console.log(params)
  
    const { endDate, startDate, fromLocationCode, toLocationCode, age, partner, ...rest } = params;
    setParams({ endDate, startDate, fromLocationCode, toLocationCode, age, partner });
  }, []); // eslint-disable-line

  const onSubmit = fields => {
    const params = {
      startDate: `${format(fields.startDate, 'dd/MM/yyyy')}T${fields.hoursFrom}:${fields.minsFrom}`,
      endDate: `${format(fields.endDate, 'dd/MM/yyyy')}T${fields.hoursTo}:${fields.minsTo}`,
      fromLocationCode: fields.fromLocation.locationCode,
      toLocationCode: fields.toLocation.locationCode,
      age: fields.age || DEFAULT_AGE,
      cur: cur,
      residency: fields.residency || residency || DEFAULT_RESIDENCY,
      ...DEFAULT_FILTERS,
    };

    // removed popup below - keep this line as a reference

    dispatch(setVendorsLoaded(false));
    dispatch(setResultsLoaded(false));
    setParams(params); // just for consistency
    // history.replace(routes.HOME + '?' + queryString.stringify(params)) <-- not sure why we had it in the first place
    // no need to apply lang because path is "search" so it remains on whatever lang prefix we are at anyway
    history.push({
      pathname: routes.SEARCH,
      search: `${queryString.stringify(params)}`
    })
    window.scrollTo(0, 0); // sometimes users see the end of the results instead of top
  };

  return (
    <div className="home flex-fill bg-white">
      <HomeContent onSubmit={onSubmit} params={params} minimized={false} residency={residency} />
    </div>
  );
}

const mapStateToProps = ({ vendors, results, ui, prefs }) => ({
  // loading: ui.loading,
  // dir: ui.direction,
  cur: prefs.cur || DEFAULT_CURRENCY, // Get currency from prefs with fallback
  residency: prefs.residency,
});

export default connect(mapStateToProps)(Home);
